import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { PrimaryPackagePart } from "../../../queries/useSearchPartPackagesByVehicle";
import { Placeholder } from "../../../ui/Placeholder";

type PackageItemListProps = {
  className?: string;
  primaryPart?: PrimaryPackagePart;
};

export const PackageItemList: FunctionComponent<PackageItemListProps> = ({
  className,
  primaryPart,
}) => {
  const [language] = useLanguage();
  const packageItem = primaryPart ? primaryPart.packageItem : [null, null];
  return (
    <div className={className}>
      {packageItem.map((item, key) => (
        <div className="text-ink" key={`${item?.itemId}-${key}`}>
          <Placeholder className="w-24" loading={!item}>
            <span className="font-medium">
              {item?.itemQuantity} &times; {item?.itemTitle[language]}{" "}
            </span>
            {item && <span className="font-thin">({item.itemPartNumber})</span>}
          </Placeholder>
        </div>
      ))}
    </div>
  );
};
